module.exports = "/fonts/vendor/primeicons/primeicons.ttf?121254f73060bcbb53ca13258dbd134f";